import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=ed01052e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed01052e')) {
      api.createRecord('ed01052e', component.options)
    } else {
      api.reload('ed01052e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=ed01052e&", function () {
      api.rerender('ed01052e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2d0yVuWTcoKnt/JS/comp/stardisplay.vue"
export default component.exports